// src/components/Footer.tsx
import React from "react";
import { Image, Space } from "antd";
import logoHeader from "../assets/icon/logo-header.svg";
import iconPhone from "../assets/icon/icon-phone.svg";
import iconEmail from "../assets/icon/icon-email.svg";
import iconLocal from "../assets/icon/icon-local.svg";

import "./Footer.css"; // File CSS riêng cho Footer

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__content">
        <img src={logoHeader} alt={`image`} className="footer__logo" />

        <div className="footer__contact">
          <div className="footer__contact-item " style={{ padding: 16 }}>
            <Space>
              <Image
                preview={false}
                src={iconPhone}
                alt={`image`}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
              <div>
                <span>Call anytime</span>
                <a href="tel:+84397504483" className="text-color-1">
                  (+84) 397504483
                </a>
              </div>
            </Space>
          </div>

          <div className="footer__contact-item footer__contact-item-line ">
            <Space>
              <Image
                preview={false}
                src={iconEmail}
                alt={`image`}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
              <div>
                <span>Send email</span>
                <a
                  href="mailto:giakhandang07@gmail.com"
                  className="text-color-1"
                >
                  giakhandang07@gmail.com
                </a>
              </div>
            </Space>
          </div>

          <div className="footer__contact-item footer__contact-item-line ">
            <Space>
              <Image
                preview={false}
                src={iconLocal}
                alt={`image`}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
              <div>
                <span>Location</span>
                <a className="text-color-1">Cau Giay, Hanoi, Vietnam</a>
              </div>
            </Space>
          </div>
        </div>
      </div>

      <div className="footer__copyright">
        © All Copyright 2024 by Dang Gia Khanh
      </div>
    </footer>
  );
};

export default Footer;
